// Loader.js
import React from 'react';

const MainLoader = () => (
  <div className="fixed inset-0 z-[1000000] flex items-center justify-center bg-[#091E428A]">
    <div className="flex items-center gap-3 rounded-md bg-white px-5 py-4 shadow-overlay">
      <div
        className="h-6 w-6 animate-spin rounded-full border-[3px] border-solid border-t-transparent"
        style={{ borderColor: '#0C66E4 transparent #0C66E4 transparent' }}
      ></div>
      <div className="text-sm font-medium text-ink">Loading...</div>
    </div>
  </div>
);

export default MainLoader;
